import { secureLogout } from "../secureApi";
// src/components/LogoutButton.jsx

import React from "react";

import {
  useNavigate,
} from "react-router-dom";

import Swal from "sweetalert2";


export default function LogoutButton({
  className = "logout-button",
}) {

  const navigate =
    useNavigate();



  /* ============================================================
     CLEAR AUTH
  ============================================================ */

  const clearLoginData = () => {

    localStorage.removeItem("auth");

    localStorage.removeItem("user");

    localStorage.removeItem("userId");

    localStorage.removeItem("userName");

    localStorage.removeItem("username");

    localStorage.removeItem("userRole");

    localStorage.removeItem("userPhone");

    localStorage.removeItem("userEmail");

    localStorage.removeItem(
      "profilePicture"
    );

    localStorage.removeItem(
      "loginTime"
    );

  };



  /* ============================================================
     LOGOUT
  ============================================================ */

  const handleLogout =
    async () => {

      const confirm =
        await Swal.fire({

          icon: "question",

          title: "Logout?",

          text:
            "Are you sure you want to logout?",

          showCancelButton: true,

          confirmButtonText:
            "Yes, Logout",

          cancelButtonText:
            "Cancel",

          confirmButtonColor:
            "#d33",

        });



      if (
        !confirm.isConfirmed
      ) {
        return;
      }



      /* ========================================================
         CLEAR CURRENT LOGIN
      ======================================================== */

      clearLoginData();



      /* ========================================================
         CROSS TAB LOGOUT SIGNAL

         Other browser tabs receive
         a STORAGE event.
      ======================================================== */

      localStorage.setItem(
        "logoutEvent",
        String(
          Date.now()
        )
      );



      /* ========================================================
         SAME TAB SIGNAL
      ======================================================== */

      window.dispatchEvent(
        new Event(
          "authChanged"
        )
      );



      /* ========================================================
         REDIRECT
      ======================================================== */

      navigate(
        "/login",
        {
          replace: true,
        }
      );

  };



  /* ============================================================
     BUTTON
  ============================================================ */

  return (

    <button
      type="button"
      className={
        className
      }
      onClick={
        handleLogout
      }
    >

      <i className="fa fa-sign-out"></i>

      &nbsp;

      Logout

    </button>

  );

}